import {Injectable} from '@angular/core'
import {BreakpointObserver} from '@angular/cdk/layout'
import {BreakpointsService} from './breakpoints.service'
import {CustomBreakpointNames} from './breakpoints.service'
import {map} from 'rxjs/operators'
import {Observable} from 'rxjs'

@Injectable({
  providedIn: 'root'
})
export class LayoutService {
  activeBreakpoints: string[] = []

  constructor(private breakpointObserver: BreakpointObserver,
              private breakpointService: BreakpointsService) {
  }

  subscribeToLayoutChanges(): Observable<string[]> {
    return this.breakpointObserver
      .observe(this.breakpointService.getBreakpoints())
      .pipe(map((observeResponse) => {
        return this.parseBreakpointsResponse(observeResponse.breakpoints)}))
  }

  handleLayoutChanges(): any{
    if (this.isBreakpointActive(CustomBreakpointNames.extraSmall)) {
      return {
        extraSmall: true,
        small: true,
        medium: false,
        large: false,
        extraLarge: false
      }
    }
    else if (this.isBreakpointActive(CustomBreakpointNames.small)) {
      return {
        extraSmall: true,
        small: true,
        medium: false,
        large: false,
        extraLarge: false
      }
    }
    else if (this.isBreakpointActive(CustomBreakpointNames.medium)) {
      return {
        extraSmall: false,
        small: false,
        medium: true,
        large: true,
        extraLarge: true
      }
    }
    else if (this.isBreakpointActive(CustomBreakpointNames.large)) {
      return {
        extraSmall: false,
        small: false,
        medium: true,
        large: true,
        extraLarge: true
      }
    }
    else if (this.isBreakpointActive(CustomBreakpointNames.extraLarge)) {
      return {
        extraSmall: false,
        small: false,
        medium: true,
        large: true,
        extraLarge: true
      }
    }
    return {
      extraSmall: false,
      small: false,
      medium: true,
      large: true,
      extraLarge: true
    }
  }

  parseBreakpointsResponse(breakpoints: any): string[] {
    this.activeBreakpoints = []

    Object.keys(breakpoints).map((key) => {
      if (breakpoints[key]) {
        this.activeBreakpoints.push(this.breakpointService.getBreakpointName(key))
      }
    })

    return this.activeBreakpoints
  }

  isBreakpointActive(breakpointName: string) {
    return this.activeBreakpoints.filter(breakpoint => breakpoint === breakpointName).length === 2
  }


}
